import { Popover } from "antd";
import React from "react";

const UploadedDocuments = ({ item , getSvgIcon, key}) => {
  return (
    <div key={key}>
      <a href={item.public_url} target="_blank" rel="noreferrer">
        {getSvgIcon(item.name)}
      </a>
      <div className="mt-1">
        <Popover content={item.name} trigger="hover">
          <span>{item.name.slice(0, 6)}...</span>
        </Popover>
      </div>
    </div>
  );
};

export default UploadedDocuments;
